module.exports = __webpack_public_path__ + "img/ico-check-person.2e8e8f6b.svg";